import { Paper, Select } from '@mui/material';
import styled from 'styled-components';
import theme from 'src/theme';

export const S = {
    stars: {
        marginLeft: '0px'
    },
    starBorderIcon: {
        color: theme.color.tuna,
        fontSize: 18
    },
    starIcon: {
        fontSize: 18
    }
};

export const StatusSelect = styled(Select)`
    min-width: 100px;
    font-size: 13px;

    & .MuiSelect-select {
        color: ${theme.color.white70};
        font-size: 12px;
    }

    & .MuiSvgIcon-root {
        color: ${theme.color.white70};
    }

    & .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.color.white70};
    }

    &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.color.white70};
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.color.white70};
    }
` as typeof Select;

export const StatusMenuPaper = styled(Paper)`
    && {
        font-size: 13px;
        background-color: ${theme.color.blackRock};
        color: ${theme.color.white70};
    }
`;
